import React from 'react';
import { WhatsAppButton } from './WhatsAppButton';

export const CTASection = ({ 
  title = "Agende seu horário agora", 
  subtitle = "Entre em contato pelo WhatsApp e garanta o melhor cuidado para seu veículo",
  backgroundColor = "bg-[#00B4D8]"
}) => {
  return (
    <section className={`${backgroundColor} py-16`}>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {title}
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <WhatsAppButton 
            text="Solicitar Orçamento" 
            className="bg-white text-[#00B4D8] hover:bg-gray-100"
          />
          <WhatsAppButton 
            text="Agendar Serviço"
          />
        </div>
      </div>
    </section>
  );
};
